// src/index.js
import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';

// Вы можете оставить или удалить './index.css' по желанию.
// Я оставил App.css в примере, так что можно удалить и эту строку.
import './App.css'; 

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);